import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=b83b57ea"
import script from "./RequestList.vue?vue&type=script&lang=ts"
export * from "./RequestList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports